import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniahireforpicnic() {



    const cardData =
    {
        keyword: 'Urbania Hire for Picnic in Pune',
        heading: 'Urbania on rent in pune: Urbania Hire for Picnic in Pune',
        headingDescription: 'Urbania On Rent in Pune provides premium and reliable Urbania Hire for Picnic in Pune services for families, friends, and group travelers planning day trips or weekend picnics around Pune. Our well-maintained Force Urbania fleet offers spacious seating, air-conditioned comfort, and smooth performance, making it ideal for outings to Lonavala, Khandala, Lavasa, Pawna Lake, and other nearby picnic spots. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, comfortable, and stress-free travel experience. Supported by 24/7 booking assistance, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for picnic Urbania hire in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum showcasing Gandhi’s personal artifacts and photographs. Its sprawling gardens and Italian arches make it a peaceful retreat. It also houses the samadhis of Kasturba Gandhi and Mahadev Desai. Aga Khan Palace is Pune’s symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for its charitable work. Devotees find immense peace and blessings here. Dagdusheth Ganpati is the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings are a testament to early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a major attraction. The museum is Pune’s living archive of art and craftsmanship."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and transformation. Osho Ashram is Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature. It is Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during monsoon. Street vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends and sunsets."
  }
],



"services": [
    {
      "name": "Urbania Hire for Picnic in Pune",
      "description": "Urbania Hire for Picnic in Pune provides spacious and comfortable Urbania vehicles for family outings, group trips, and day picnics. With professional chauffeurs, ample luggage space, and air-conditioned or non-AC options, the service ensures a relaxed and enjoyable travel experience for all types of picnic trips."
    },
    {
      "name": "Picnic Urbania Bus Hire Pune",
      "description": "Picnic Urbania Bus Hire Pune offers large buses suitable for group picnics, corporate outings, and social events. Equipped with comfortable seating, air-conditioning, and professional drivers, it ensures safe, timely, and stress-free transportation for all picnic participants."
    },
    {
      "name": "Urbania for Group Picnic Pune",
      "description": "Urbania for Group Picnic Pune specializes in organized transport solutions for families, friends, and corporate teams traveling for picnics. With spacious vehicles, professional chauffeurs, and reliable service, it provides a smooth and enjoyable journey for large groups."
    },
    {
      "name": "Urbania AC Bus Picnic Hire Pune",
      "description": "Urbania AC Bus Picnic Hire Pune delivers fully air-conditioned buses for comfortable group travel to picnic destinations. With ample seating, luggage space, and trained drivers, it ensures a pleasant and hassle-free experience for long and short-distance picnic trips."
    },
    {
      "name": "Family Picnic Urbania Pune",
      "description": "Family Picnic Urbania Pune provides safe and comfortable vehicles for family outings and day trips. With courteous chauffeurs, clean interiors, and convenient amenities, families can enjoy a relaxed and enjoyable picnic travel experience within Pune and nearby destinations."
    },
    {
      "name": "Corporate Picnic Urbania Pune",
      "description": "Corporate Picnic Urbania Pune offers organized transportation for company outings, team-building events, and corporate picnics. With spacious vehicles, professional drivers, and scheduled services, it ensures a smooth, safe, and efficient travel experience for employees and teams."
    },
    {
      "name": "Affordable Picnic Urbania Hire Pune",
      "description": "Affordable Picnic Urbania Hire Pune provides cost-effective picnic transport solutions without compromising comfort or quality. With well-maintained vehicles, experienced chauffeurs, and reliable service, it is ideal for families, groups, and corporate clients seeking economical picnic travel options."
    },
    {
      "name": "Luxury Picnic Urbania Pune",
      "description": "Luxury Picnic Urbania Pune offers high-end vehicles for a premium picnic experience. Equipped with air-conditioning, plush seating, and professional chauffeurs, it ensures a stylish, comfortable, and memorable travel experience for family outings, group trips, and corporate events."
    },
    {
      "name": "Chauffeur Driven Picnic Urbania Pune",
      "description": "Chauffeur Driven Picnic Urbania Pune provides stress-free and safe travel for picnic trips with trained, background-verified drivers. Vehicles are spacious, well-maintained, and suitable for city or outstation picnic destinations, allowing passengers to enjoy a relaxed journey."
    },
    {
      "name": "Urbania for School Picnic Pune",
      "description": "Urbania for School Picnic Pune delivers safe and organized transport solutions for school outings and educational trips. With experienced chauffeurs, well-maintained buses, and spacious seating, students can travel comfortably and securely to picnic and excursion destinations."
    },
    {
      "name": "Urbania for College Picnic Pune",
      "description": "Urbania for College Picnic Pune provides reliable and comfortable vehicles for college outings, trips, and group excursions. Equipped with professional drivers, sufficient seating, and air-conditioned or non-AC options, it ensures a fun, safe, and hassle-free travel experience for students."
    },
    {
      "name": "Safe Picnic Urbania Hire Pune",
      "description": "Safe Picnic Urbania Hire Pune emphasizes safety and comfort for all picnic trips. Vehicles are well-maintained, drivers are trained and verified, and travel schedules are punctual, ensuring a secure and pleasant journey for families, students, and corporate groups."
    },
    {
      "name": "Best Picnic Urbania Rental Pune",
      "description": "Best Picnic Urbania Rental Pune offers top-rated picnic transportation services known for reliability, vehicle quality, and customer satisfaction. Ideal for family trips, group outings, and corporate picnics, it ensures a smooth, safe, and enjoyable travel experience."
    },
    {
      "name": "Urbania for One Day Picnic Pune",
      "description": "Urbania for One Day Picnic Pune provides vehicles specifically for day trips and short-distance picnic outings. With professional chauffeurs, ample seating, and reliable service, it allows passengers to enjoy a comfortable and stress-free one-day travel experience."
    },
    {
      "name": "Group Travel Urbania for Picnic Pune",
      "description": "Group Travel Urbania for Picnic Pune specializes in transporting large groups to picnic destinations efficiently and comfortably. With spacious vehicles, trained drivers, and reliable scheduling, it ensures an enjoyable and hassle-free group travel experience."
    }
  ],
  "tableData": [
    ["Urbania Hire for Picnic in Pune", "Picnic Urbania Bus Hire Pune"],
    ["Urbania for Group Picnic Pune", "Urbania AC Bus Picnic Hire Pune"],
    ["Family Picnic Urbania Pune", "Corporate Picnic Urbania Pune"],
    ["Affordable Picnic Urbania Hire Pune", "Luxury Picnic Urbania Pune"],
    ["Chauffeur Driven Picnic Urbania Pune", "Urbania for School Picnic Pune"],
    ["Urbania for College Picnic Pune", "Safe Picnic Urbania Hire Pune"],
    ["Best Picnic Urbania Rental Pune", "Urbania for One Day Picnic Pune"],
    ["Group Travel Urbania for Picnic Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania Hire for Picnic in Pune",
        "WhyChoosedescription": "Urbania Hire for Picnic in Pune is perfect for group outings, family picnics, and friends’ trips, providing comfortable and spacious travel for everyone."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania Hire for Picnic in Pune offers well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and enjoyable journey."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania Hire for Picnic in Pune comes with skilled drivers who are familiar with Pune and nearby picnic spots, ensuring safe and hassle-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania Hire for Picnic in Pune for competitive pricing with no hidden charges, making group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania Hire for Picnic in Pune provides round-the-clock assistance for bookings, inquiries, and last-minute picnic travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Picnic Packages",
        "WhyChoosedescription": "Urbania Hire for Picnic in Pune offers hourly rentals, full-day bookings, and customized picnic packages for local trips and nearby hill stations."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for Urbania Hire for Picnic in Pune are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania Hire for Picnic in Pune guarantees timely pickups and dependable service, ensuring smooth and stress-free travel for your picnic."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania Hire for Picnic in Pune available for day trips?',
        answer: 'Yes, Urbania Hire for Picnic in Pune is ideal for day trips, local sightseeing, and outings to nearby picnic spots.',
    },
    {
        question: 'How can I book Urbania Hire for Picnic in Pune?',
        answer: 'You can book Urbania Hire for Picnic in Pune via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania Hire for Picnic in Pune for group outings?',
        answer: 'Urbania Hire for Picnic in Pune provides spacious seating, comfortable rides, and professional drivers, making it ideal for family and group trips.',
    },
    {
        question: 'Are the drivers experienced with Urbania Hire for Picnic in Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles for picnic and local travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania Hire for Picnic in Pune?',
        answer: 'Absolutely. Urbania Hire for Picnic in Pune allows flexible pickup and drop-off locations across Pune and nearby picnic destinations.',
    },
    {
        question: 'Is Urbania Hire for Picnic in Pune available 24x7?',
        answer: 'Yes, Urbania Hire for Picnic in Pune operates 24x7 to meet your travel needs at any time of the day.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania Hire for Picnic in Pune?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for your picnic trips.',
    },
    {
        question: 'What payment options are available for Urbania Hire for Picnic in Pune?',
        answer: 'Urbania Hire for Picnic in Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free picnic experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ankit Sharma',
        feedback: 'We hired Urbania for a picnic trip with friends. The vehicle was spacious, comfortable, and the service was punctual. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Shreya Joshi',
        feedback: 'Urbania Hire for Picnic in Pune made our family outing very smooth and enjoyable. Professional driver and well-maintained vehicle.',
        rating: 5,
    },
];


































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Picnic in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-picnic-pune.jpg",
  "description": "Urbania Hire for Picnic in Pune offers AC and non-AC Urbania buses for family, corporate, school, and college picnic trips. Perfect for one-day or group excursions. Chauffeur-driven Urbania buses ensure safe, comfortable, and enjoyable picnic travel in and around Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-hire-for-picnic-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania Hire for Picnic in Pune | AC & Luxury Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Urbania Hire for Picnic in Pune for family, corporate, school, or college trips. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and enjoyable picnic travel in and around Pune."
  />

  <meta
    name="keywords"
    content="Urbania Hire for Picnic in Pune, Picnic Urbania Bus Hire Pune, Urbania for Group Picnic Pune, Urbania AC Bus Picnic Hire Pune, Family Picnic Urbania Pune, Corporate Picnic Urbania Pune, Affordable Picnic Urbania Hire Pune, Luxury Picnic Urbania Pune, Chauffeur Driven Picnic Urbania Pune, Urbania for School Picnic Pune, Urbania for College Picnic Pune, Safe Picnic Urbania Hire Pune, Best Picnic Urbania Rental Pune, Urbania for One Day Picnic Pune, Group Travel Urbania for Picnic Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/46.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniahireforpicnic;